import React, { createContext } from 'react'
import { BaseContextState, BaseContextProvider } from '../BaseContext'
import IMappingSex from '../../interfaces/IMappingSex'
import { SearchRequest, MappingSexSaveRequest } from '../../services/api/interfaces/ApiRequest'
import { mappingSexList, mappingSexSave } from '../../services/api'

interface MappingSexContextState extends BaseContextState {
  mappingSexs: Array<IMappingSex> | null,
  mappingSex: IMappingSex | null
}

interface MappingSexContextData extends MappingSexContextState {
  resetErrors: Function,
  requestMappingSexList: (args: SearchRequest) => Promise<any>,
  requestMappingSexFind: (args: SearchRequest) => Promise<any>,
  requestMappingSexSave: (args: MappingSexSaveRequest) => void,
}

// Create context
const { Provider, Consumer } = createContext({} as MappingSexContextData)

// Export consumer
export const MappingSexConsumer = Consumer

export class MappingSexProvider extends BaseContextProvider {
  state: MappingSexContextState = {
    mappingSexs: null,
    mappingSex: null
  }

  /**
   * Make api request for mapping sex list
   * 
   * @param {SearchRequest} payload 
   */
  requestMappingSexList = (payload: SearchRequest) => {
    return new Promise((resolve, reject) => {
      this.setState({
        fetching: true,
        error: null
      }, async () => {
        const response = await mappingSexList(payload)
  
        // Process our response
        this.processResponse(response, { 
          paginate: {
            destination: 'mappingSexs'
          },
        })

        if (this.state.success) {
          resolve(true)
        } else {
          reject(this.state.error)
        }
      })
    })
  }

  /**
   * Make api request for mapping sex finder
   * 
   * @param {SearchRequest} payload 
   */
  requestMappingSexFind = (payload: SearchRequest) => {
    return new Promise((resolve, reject) => {
      this.setState({
        fetching: true,
        error: null,
        mappingSex: null
      }, async () => {
        payload.options = {
          ...payload.options,
          _single: true
        }
  
        const response = await mappingSexList(payload)
  
        // Process our response
        this.processResponse(response, { 
          mappings: {
            destination: 'mappingSex'
          },
        })

        if (this.state.success) {
          resolve(true)
        } else {
          reject(this.state.error)
        }
      })
    })
  }

  /**
   * Make api request for mapping sex save
   * 
   * @param {MappingSexSaveRequest} payload 
   */
  requestMappingSexSave = (payload: MappingSexSaveRequest) => {
    this.setState({
      fetching: true,
      error: null,
      mappingSex: null
    }, async () => {
      const response = await mappingSexSave(payload)

      // Process our response
      this.processResponse(response, {
        mappings: [
          { origin: 'mapping_sex', destination: 'mappingSex' }
        ]
      })
    })
  }

  render() {
    return (
      <Provider
        value={{
          // States
          ...this.state,

          // Dispatches
          resetErrors: this.resetErrors,
          requestMappingSexList: this.requestMappingSexList,
          requestMappingSexFind: this.requestMappingSexFind,
          requestMappingSexSave: this.requestMappingSexSave
        }}
      >
        {this.props.children}
      </Provider>
    )
  }
}
